import React from "react";

import Breadcrumb from "../components/Breadcrumb";
import AddCourseCommunityLayer from "../components/AddCourseCommunityLayer";
 
 
const AddCourseCommunityPage = () => {
  return (
    <>


 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Course Community  </h5><Breadcrumb title="Add Course Community" /></div>
 
        {/* CalendarMainLayer */}
        <AddCourseCommunityLayer />
 
 
  
    </>
  );
};
 
export default AddCourseCommunityPage;
 
 